import buildApiResponse from './buildApiResponse';

export default buildApiResponse;
